export const SIDENAV = 'UI/SIDENAV';
export const FILTER = 'UI/FILTER';
export const MODAL = 'UI/MODAL';
export const PROFILE_NAV = 'UI/PROFILE_NAV';
